import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  data: {},
  steps: {
    1: {
      id: 1,
      title: 'service.charges.commission.for.returns',
      component: 'RefundCommission',
    },
    2: {
      id: 2,
      title: 'choose.way.up.your.balance',
      component: 'BalanceReplenishment',
    },
    3: {
      id: 3,
      title: 'indicate.reason.for.return',
      component: 'IndicateReasonReturn',
    },
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
